import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

// view

import Loading from 'components/Loading';
import {
  PersonalProfile,
  PersonalExpenses,
  Calendar,
  Timestamp,
  CheckIn,
  CheckOut,
  EditExpenses,
  AddOtRequest,
  OvertimeRequestList,
  ExpensesDetail,
  LeaveRequestList,
  AddLeaveRequest,
  FuelSetting,
  FieldAllowanceRequestList,
  PaymentApproval,
  ExpenseReview,
  BudgetApproval,
  PermissionSettings,
} from '../views/Profile';
import AiChat from '../views/Management/AiChat';
//

import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Profile() {
  const module = 'PROFILE';
  const prefix = '/profile';
  const name = 'ข้อมูลส่วนตัว';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  useEffect(() => {
    dispatch(actions.meGet());

    return () => {};
  }, []);
  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="ข้อมูลส่วนตัว" />;
  }
  return (
    <div className="min-h-screen">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div className={`relative ${'lg:ml-20'} transition-all duration-200 min-h-screen pt-2 lg:px-8 px-4`}>
        <div className="py-4">
          <Switch>
            {' '}
            <Route exact path={`${prefix}/`}>
              <Calendar title="ปฏิทิน" subtitle={name} />
            </Route>{' '}
            <Route exact path={`${prefix}/ot`}>
              <OvertimeRequestList title="คำขอโอที" subtitle={name} />
            </Route>{' '}
            <Route exact path={`${prefix}/timestamp`}>
              <Timestamp title="บันทึกเวลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp/Check-In`}>
              <CheckIn title="เข้างาน" subtitle={name} />
            </Route>{' '}
            <Route exact path={`${prefix}/timestamp/Check-out/:id`}>
              <CheckOut title="ออกงาน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp/ot/add/:id`}>
              <AddOtRequest title="คำขอโอที" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/profile`}>
              <PersonalProfile title="โปรไฟล์" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/disbursement`}>
              <PersonalExpenses title="การเบิกจ่าย" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/crl-disbursement`}>
              <PersonalExpenses title="ตั้งเบิก CRL" subtitle={name} crlOnly />
            </Route>
            <Route exact path={`${prefix}/disbursement/edit/:id`}>
              <EditExpenses title="แก้ไข" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/disbursement/detail/:id`}>
              <ExpensesDetail title="รายละเอียด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/leave`}>
              <LeaveRequestList title="คำขอลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/leave/add`}>
              <AddLeaveRequest title="ยื่นคำขอลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/field-allowance`}>
              <FieldAllowanceRequestList title="คำขอค่าออกสนาม" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/fuel-setting`}>
              <FuelSetting title="การตั้งเบิกน้ำมันรถ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/payment-approval`}>
              <PaymentApproval title="อนุมัติการจ่ายเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expense-review`}>
              <ExpenseReview title="ตรวจสอบรายการเบิกเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/budget-approval`}>
              <BudgetApproval title="อนุมัติ budget" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/ai-chat`}>
              <AiChat />
            </Route>
            <Route exact path={`${prefix}/permissions`}>
              <PermissionSettings />
            </Route>
            <Route exact path={`${prefix}/calendar`}>
              <Calendar title="CALENDAR" subtitle={name} />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      <div className={`${'lg:ml-20'} transition-all duration-200`}>
        <MainFooter />
      </div>
    </div>
  );
}

export default Profile;
